import { Button, message } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import BasicLayout from "../../components/BasicLayout/index";
import FallBack from "../../components/common/FallBack/FallBack";
import Tables from "../../components/common/Table/Table";
import { useDeleteAction } from "../../components/Hooks/useDeleteAction";
import useExportCsv from "../../components/Hooks/useExportCsv";
import useTableSearch from "../../components/Hooks/useTableSearch";
import { getNewsLetter, softDeleteNewsLetter } from "../../store/actions/other/other.action";
import { DeleteModel } from "../../utils/DeleteModel";
import { formatFileName } from "../../utils/helper";

const NewsLetter = (props) => {
	const [getColumnSearchProps] = useTableSearch();
	const [exportToCSV] = useExportCsv();
	const { deleteData } = useDeleteAction();
	const [deleteId, setDeleteId] = useState(undefined);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const dispatch = useDispatch();
	const newsletter = useSelector((state) => state.other.newsletter || []);

	const admin = useSelector((state) => state.admin.admin || {});

	const permissionArr = useMemo(() => {
		if (admin && admin.template) {
			const { permissions } = admin.template;
			return permissions;
		} else if (admin && admin.accessLevel === "superAdmin") {
			return "all";
		}
		return [];
	}, [admin]);

	useEffect(() => {
		dispatch(getNewsLetter());
	}, [dispatch]);

	async function confirm(id, reason) {
		await deleteData(id, reason, softDeleteNewsLetter, setIsModalVisible);
	}
	const columns = [
		{
			title: "Id",
			dataIndex: "id",
			key: "id",
		},
		{
			title: "Email",
			dataIndex: "email",
			key: "email",
			...getColumnSearchProps("email"),
		},
		{
			title: "Email Sent",
			dataIndex: "totalEmailSent",
			key: "totalEmailSent",
		},
		{
			title: "Active",
			dataIndex: "status",
			key: "status",
			...getColumnSearchProps("status"),
		},
		{
			title: "Received",
			dataIndex: "createdAt",
			key: "createdAt",
		},
		{
			title: "Action",
			key: "action",
			render: (_text, record) => (
				<DeleteModel
					view={false}
					record={record}
					confirm={confirm}
					update="false"
					setIsModalVisible={setIsModalVisible}
					isModalVisible={isModalVisible}
					cancelMessage="Newsletter Removing has been cancelled"
					linkUrl={`/other/newsletter`}
					placeholder="Please enter reason to delete newsletter"
					deleteId={deleteId}
					setDeleteId={setDeleteId}
					isdelete={
						permissionArr === "all"
							? "true"
							: permissionArr?.other?.newsletter.filter((item) => item === "delete")?.length > 0
							? "true"
							: false
					}
				/>
			),
		},
	];
	const fileName = formatFileName("newsletter", "xlsx",admin);
	let dataSource = [];
	if (newsletter.length > 0) {
		dataSource = newsletter.sort(function (a, b) {
			return new Date(b.updatedAt) - new Date(a.updatedAt);
		});
		dataSource = dataSource.map((row, index) => ({
			...row,
			createdAt: new Date(row.createdAt).toLocaleString(),
			key: row.id,
			status: row.status ? "Yes" : "No",
		}));
	}

	const handleError = (error) => {
		message.error(error.message);
	};

	return (
		<BasicLayout accessLevel={props.accessLevel}>
			<ErrorBoundary FallbackComponent={FallBack} onError={handleError}>
				<div className="button-style-to-right">
					{permissionArr === "all" ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(newsletter, fileName)}>
							Export
						</Button>
					) : permissionArr?.other?.newsletter?.filter((item) => item === "export")?.length > 0 &&
					  newsletter?.length !== 0 ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(newsletter, fileName)}>
							Export
						</Button>
					) : null}
				</div>

				<Tables
					dataSource={dataSource}
					columns={columns}
					footerText={`Total Subscription Received: ${newsletter.length}`}
				/>
			</ErrorBoundary>
		</BasicLayout>
	);
};

export default NewsLetter;
